import { Stack, Typography } from '@mui/material';
import { useInvestigationDetails } from '@hooks/useInvestigationDetails';
import { RefObject, useContext, useEffect, useState } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { InvestigationTransaction } from '../TransactionsComponentsVariants/TransactionsTable/transactions.types';
import { INVESTIGATION_STATUS } from '@/types/GeneralTypes';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from 'src/types/RefineAnalyticsEvents';
import { useFeatureFlagVariantKey } from 'posthog-js/react';
import { refineFonts } from '@/Theming/refineFonts';
import { OUCFDeadlineDialogVariant } from '../OUCFDeadlineVariants/OUCFDeadlineDialogVariant';
import { OUCFDeadlineDropdown } from '../OUCFDeadlineVariants/OUCFDeadlineDropdown';
import { TransactionsTable } from '@components/TransactionsComponentsVariants/TransactionsTable/TransactionsTable';

interface IWelcomeScreenProps {
	handleOnClickNext: () => void;
}

export default function WelcomeScreenComponent(props: IWelcomeScreenProps) {
	const [preparedTransactions, setPreparedTransactions] = useState<InvestigationTransaction[]>([]);
	const investigationDetails = useInvestigationDetails();
	const { WelcomeScreen: text } = useContext(LocalizationContext);
	const { trackRefineEvent } = useAnalytics();
	//const posthog = usePostHog();
	//posthog.featureFlags.override({ transactionsListVariant: 'control' });
	const oucfDeadlineVariant = useFeatureFlagVariantKey('oucfDeadlineVariant');

	useEffect(() => {
		if (investigationDetails?.transactions && Object.keys(investigationDetails.transactions).length > 0) {
			setPreparedTransactions(investigationDetails.transactions);
		} else {
			setPreparedTransactions([]);
		}
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.WELCOME_SCREEN_LOADED);
	}, [investigationDetails]);

	const renderName = () => {
		if (investigationDetails && investigationDetails.status === INVESTIGATION_STATUS.BEGINNING) {
			sessionStorage.setItem('investigationContextOpened', new Date().getTime().toString());
			return investigationDetails.account.customerName + ',';
		}
		return ','; // No name found
	};

	const scrollToTarget = (scrollTargetRef: RefObject<HTMLDivElement | null>) => {
		setTimeout(() => {
			if (scrollTargetRef.current) {
				scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' });
			}
		}, 200);
	};

	if (!investigationDetails) return <></>;

	const isCheckTransaction = investigationDetails?.nextQuestion?.type === 'oucfCheckQuestion';
	return (
		<Stack
			paddingTop={{
				xxs: '16px',
				xs: '16px',
				sm: '48px',
				md: '48px',
				lg: '48px',
				xl: '48px',
			}}
			overflow={'scroll'}
			data-cy={'pqWelcomeScreen'}
			direction={'column'}
			gap={'8px'}>
			<Stack tabIndex={0} aria-label={text.Greeting.replace('%1$s', renderName())} data-private="redact">
				<Typography variant={'welcomeScreenName'}>{text.Greeting.replace('%1$s', renderName())}</Typography>
			</Stack>
			<Stack maxWidth={'900px'} aria-label={investigationDetails?.bankerOutreachText} data-private="redact">
				<Typography
					sx={{ ...refineFonts.xLargeRegular, letterSpacing: '0.1px' }}
					data-cy={'pqBankerOutreachText'}>
					{investigationDetails?.bankerOutreachText}
				</Typography>
			</Stack>
			{isCheckTransaction && (
				<>
					{oucfDeadlineVariant === 'control' && <OUCFDeadlineDialogVariant />}
					{oucfDeadlineVariant === 'dropdown' && <OUCFDeadlineDropdown scrollToTarget={scrollToTarget} />}
				</>
			)}
			{Boolean(preparedTransactions.length) && !isCheckTransaction && (
				<TransactionsTable rows={preparedTransactions} />
			)}
		</Stack>
	);
}
